import { connect } from 'react-redux';
import { useTranslation } from '@eti/providers';
import { getPriceProps } from '../../common/utils/productCardProps';
import { getProduct } from '../../single-choice/utils/singleChoiceTransformer';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { useProductData } from '../../common/hook/useProductData';
import { getSelected } from '../../single-choice/utils/selection';
import { AIRPORT_TRANSFER } from '../../products';
import { ProductCardLayoutType } from '../../common/models/product';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = AIRPORT_TRANSFER;
const sharedTexts = {
  abstractContent: 'airportTransferAbstract',
  readMoreContent: 'airportTransferReadMoreModalContent',
  title: 'airportTransferTitle',
  upSell: 'airportTransferUpSellText',
  generalPurpose: 'airportTransferGeneralPurpose'
};
const AirportTransfer = _ref => {
  var _externalChoices$filt, _externalChoices;
  let {
    form,
    layoutType = ProductCardLayoutType.Main,
    isSelected,
    order,
    productPosition,
    sellSpecification,
    className
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    productData,
    rootElement
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    sellSpecification,
    texts: sharedTexts
  });
  if (!productData) {
    return null;
  }
  const product = getProduct(PRODUCT_ID, order, 'none');
  if (!product) {
    return null;
  }
  const priceRaw = (_externalChoices$filt = sellSpecification === null || sellSpecification === void 0 || (_externalChoices = sellSpecification.externalChoices) === null || _externalChoices === void 0 || (_externalChoices = _externalChoices.filter(choice => choice.ancillaryOption === 'CHEAPEST')) === null || _externalChoices === void 0 || (_externalChoices = _externalChoices[0]) === null || _externalChoices === void 0 || (_externalChoices = _externalChoices.pricePerTravelers) === null || _externalChoices === void 0 || (_externalChoices = _externalChoices[0]) === null || _externalChoices === void 0 || (_externalChoices = _externalChoices.price) === null || _externalChoices === void 0 ? void 0 : _externalChoices.price.value) !== null && _externalChoices$filt !== void 0 ? _externalChoices$filt : 0;
  const {
    price
  } = getPriceProps(t, isSelected, {
    ...product,
    priceRaw
  });
  return /*#__PURE__*/_jsx(ProductLayout, {
    productData: {
      ...productData,
      priceRaw,
      price
    },
    ref: rootElement
  });
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  const productName = AIRPORT_TRANSFER.name;
  return {
    isSelected: getSelected(productName, form)(state)
  };
};
export default connect(mapStateToProps)(AirportTransfer);
//# sourceMappingURL=AirportTransfer.js.map